import {ClientMarketDataMarkupModel} from '@spa/api';

export const UpdteMarketDataFeedMarkupAskPriceSelector = 'UpdteMarketDataFeedMarkupAskPrice';
export const UpdteMarketDataFeedMarkupBidPriceSelector = 'UpdteMarketDataFeedMarkupBidPrice';
export const UpdteMarketDataFeedMarkupSymbolSelector = 'UpdteMarketDataFeedMarkupSymbol';
export const UpdteMarketDataFeedMarkupLevelSelector = 'UpdteMarketDataFeedMarkupLevel';
export const UpdteMarketDataFeedMarkupTypeSelector = 'UpdteMarketDataFeedMarkupType';

export const getClonedMarketDataModel = (collection: ClientMarketDataMarkupModel[]): ClientMarketDataMarkupModel[] => {
    const clonedData = [];

    if (!collection || collection.length === 0) {
        return clonedData;
    }

    collection.forEach(model => {
        clonedData.push(new ClientMarketDataMarkupModel({
            userId: model.userId,
            userFirstName: model.userFirstName,
            userLastName: model.userLastName,
            markups: model.markups.map(markup => Object.assign({}, markup)), // for the deepCopy
            isEditMode: model.isEditMode,
            isShowNewRowForm: model.isShowNewRowForm,
            userStatus: model.userStatus,
            userRelationType: model.userRelationType,
        }));
    });

    return clonedData;
};
